<template>
  <div>
    <v-row justify="center" align="center">
      <v-col cols="12" md="10" sm="12">
        <v-sheet elevation="0" class="px-5 py-2 text-center" rounded>
          <!--//*team depth data table -->
          <div class="mt-2">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center">POS</th>
                    <th class="text-center">1</th>
                    <th class="text-center">2</th>
                    <th class="text-center">3</th>
                  </tr>
                </thead>

                <tbody>
                  <!-- //* -->
                  <tr>
                    <td class="font-weight-bold">PG</td>
                    <td
                      v-for="(player, index) in computedPGplayers"
                      :key="index"
                    >
                      <router-link
                        :to="{
                          name: 'PlayerDetail',
                          params: {
                            playerId: player.PlayerID,
                            SportId: player.SportId,
                          },
                        }"
                        style="text-decoration: none"
                        class="body-2"
                      >
                        <p>{{ player.FirstName }} {{ player.LastName }}</p>
                      </router-link>
                    </td>
                  </tr>

                  <!--//*  -->
                  <tr>
                    <td class="font-weight-bold">SG</td>
                    <td
                      v-for="(player, index) in computedSGplayers"
                      :key="index"
                    >
                      <router-link
                        :to="{
                          name: 'PlayerDetail',
                          params: {
                            playerId: player.PlayerID,
                            SportId: player.SportId,
                          },
                        }"
                        style="text-decoration: none"
                        class="body-2"
                      >
                        <p>{{ player.FirstName }} {{ player.LastName }}</p>
                      </router-link>
                    </td>
                  </tr>

                  <!--//*  -->
                  <tr>
                    <td class="font-weight-bold">PF</td>
                    <td
                      v-for="(player, index) in computedPFplayers"
                      :key="index"
                    >
                      <router-link
                        :to="{
                          name: 'PlayerDetail',
                          params: {
                            playerId: player.PlayerID,
                            SportId: player.SportId,
                          },
                        }"
                        style="text-decoration: none"
                        class="body-2"
                      >
                        <p>{{ player.FirstName }} {{ player.LastName }}</p>
                      </router-link>
                    </td>
                  </tr>

                  <!--//*  -->
                  <tr>
                    <td class="font-weight-bold">SF</td>
                    <td
                      v-for="(player, index) in computedSFplayers"
                      :key="index"
                    >
                      <router-link
                        :to="{
                          name: 'PlayerDetail',
                          params: {
                            playerId: player.PlayerID,
                            SportId: player.SportId,
                          },
                        }"
                        style="text-decoration: none"
                        class="body-2"
                      >
                        <p>{{ player.FirstName }} {{ player.LastName }}</p>
                      </router-link>
                    </td>
                  </tr>

                  <!--//*  -->
                  <tr>
                    <td class="font-weight-bold">C</td>
                    <td
                      v-for="(player, index) in computedCplayers"
                      :key="index"
                    >
                      <router-link
                        :to="{
                          name: 'PlayerDetail',
                          params: {
                            playerId: player.PlayerID,
                            SportId: player.SportId,
                          },
                        }"
                        style="text-decoration: none"
                        class="body-2"
                      >
                        <p>{{ player.FirstName }} {{ player.LastName }}</p>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
          <!--team depth data table ends -->
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  name: "nba-depthchart",
  props: {
    depthChart: {
      type: [Array, Object],
      default: () => [],
    },
  },

  computed: {
    computedPGplayers() {
      if (this.depthChart.FantasyPlayer) {
        let newArr = [];
        newArr = _.uniqBy(
          this.depthChart.FantasyPlayer.FPGplayer,
          "DepthChartOrder"
        );
        return newArr;
      }
    },

    computedSGplayers() {
      if (this.depthChart.FantasyPlayer) {
        let newArr = [];
        newArr = _.uniqBy(
          this.depthChart.FantasyPlayer.FSGplayer,
          "DepthChartOrder"
        );
        return newArr;
      }
    },

    computedPFplayers() {
      if (this.depthChart.FantasyPlayer) {
        let newArr = [];
        newArr = _.uniqBy(
          this.depthChart.FantasyPlayer.FPFplayer,
          "DepthChartOrder"
        );
        return newArr;
      }
    },

    computedSFplayers() {
      if (this.depthChart.FantasyPlayer) {
        let newArr = [];
        newArr = _.uniqBy(
          this.depthChart.FantasyPlayer.FSFplayer,
          "DepthChartOrder"
        );
        return newArr;
      }
    },

    computedCplayers() {
      if (this.depthChart.FantasyPlayer) {
        let newArr = [];
        newArr = _.uniqBy(
          this.depthChart.FantasyPlayer.FCplayer,
          "DepthChartOrder"
        );
        return newArr;
      }
    },
  },
  data() {
    return {
      Position: [
        { id: "1", position: "PG" },
        { id: "2", position: "SG" },
        { id: "3", position: "PF" },
        { id: "4", position: "SF" },
        { id: "5", position: "C" },
      ],
    };
  },
};
</script>

<style></style>
